export const SIGNUPSTARTED = 'SIGNUPSTARTED';
export const SIGNUPSUCCESSED = 'SIGNUPSUCCESSED';
export const SIGNUPERROR = 'SIGNUPERROR';